import 'nprogress/nprogress.css';// Progress 进度条样式
import { getToken } from '@/utils/auth'; // 验权
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // Progress 进度条
import router from './router';
import store from './store';

const { pathToRegexp } = require("path-to-regexp");
NProgress.configure({ showSpinner: false });

router.beforeEach((to, from, next) => {
    // 判断角色是否有权限
    if(to.fullPath === '/404' && to.redirectedFrom) {
        const noPaths = store.state.permission.noPaths; // 没有权限的路由
        const isHas = noPaths.find(path => {
            const fullPath = to.redirectedFrom.indexOf('/') != 0 ? ('/' + to.redirectedFrom) : to.redirectedFrom;
            var regexp = pathToRegexp(path, [], { end: false });
            const val = regexp.exec(fullPath);
            return !!val;
        });
        // console.log('404', to, isHas);
        if(isHas) {
            next("/401");
            return;
        }
    }
    NProgress.start();
    if(getToken()) {
        if(to.path == "/login") {
            next("/");
        }else {
            if(store.getters.modules.length == 0) {
                store.dispatch('GetInfo').then(res => {
                    // 拉取用户信息
                    store.dispatch('GenerateRoutes', res.data.empId).then((addRouters) => {
                        router.addRoutes(addRouters);
                        next({ ...to, replace: true });
                    }).catch(() => {
                        store.dispatch('FedLogOut').then(() => {
                            Message.error('获取权限失败,请重新登录');
                            next('/');
                        });
                    });
                }).catch(() => {
                    store.dispatch('FedLogOut').then(() => {
                        Message.error('验证失败,请重新登录');
                        next('/');
                    });
                });
            }else {
                next();
            }
        }
        // 退出登录会清空角色，重新拉取新路由
    }else {
        if(to.meta.white) {
            next();
        }else {
            next('/');
        }
    }

    /**
     * 路由最多缓存3个
     * 大于时，去掉最前面一个
    */
    store.dispatch('AddCachedView', to);
    if(to.meta.activeMenu) {
        if(to.meta.activeMenu == from.meta.activeMenu || to.meta.activeMenu == from.path) {
            store.dispatch('AddCachedView', from);
        }else {
            if(Array.isArray(store.getters.cachedViews) && store.getters.cachedViews.length > 2) {
                store.dispatch('DelCachedView', from);
            }
        }
    }else {
        store.dispatch('DelCachedView', from);
    }
});

router.afterEach(() => {
    NProgress.done(); // 结束Progress
});
